import { Box, Slider, Stack } from "@mui/material"
import { seekSlider } from "../styles"
import { getFormatted } from "../utils"
import dayjs from "dayjs"

interface SeekSliderProps {
    loadedSeconds:number
    playedSeconds:number
    handleMoveProgress:(event: Event, newValue: number | number[])=>void
    start?: number
    end?: number
    duration?: number
    faceProcessingServiceResult?: any
}

const sliderStyle = {
  margin: 0,
  '& .MuiSlider-mark': {
    backgroundColor: 'red',
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    marginLeft: '-3px'
  },
  '& .MuiSlider-markLabel': {
    color: '#FFF',
    top: '-10px',
  },
  '& .MuiSlider-thumb': {
    zIndex: '99',
  },
}

const redSliderStyle = {
  position: 'absolute', left: 0, top: 0, pointerEvents: 'none',
  '& .MuiSlider-track': { backgroundColor: 'red', border: 'none' },
  '& .MuiSlider-thumb': { display: 'none' },
  '& .MuiSlider-rail': { display: 'none' },
}

//TODO: Проблемы с точностью и синхронизацией видео со слайдером. Где начинается округление до целого числа, в присвоении, там и нужно округлять setLoadedSeconds и д.р.
export const SeekSlider = ({loadedSeconds, playedSeconds, handleMoveProgress, start = 0, end = 0, duration = 0, faceProcessingServiceResult}:SeekSliderProps) => {
    return (
        <Stack sx={seekSlider}>
            {getFormatted(playedSeconds>start?(playedSeconds-start):0)}
            <Box sx={{ position: 'relative' , width: '100%' }}>
              <Slider
                    min={0} max={Math.round(end?(end-start):start?(duration-start>0?duration-start:0):duration)} 
                    step={1}
                    value={Math.round(playedSeconds-start)}
                    onChange={handleMoveProgress}
                    sx={sliderStyle}
                />
                {faceProcessingServiceResult && faceProcessingServiceResult?.target_found === false && (
                    <Slider
                        min={0} max={Math.round(end ? (end - start) : start ? (duration - start > 0 ? duration - start : 0) : duration)} step={1}
                        aria-labelledby="track-range-slider"
                        value={[0, Math.round(duration)]}
                        sx={redSliderStyle}
                    />
                )}
                {faceProcessingServiceResult && faceProcessingServiceResult?.strangers_count > 0 &&
                  faceProcessingServiceResult.stranger_tracks.map((item: any) => (
                    <Slider
                        min={0} max={Math.round(end ? (end - start) : start ? (duration - start > 0 ? duration - start : 0) : duration)} step={1}
                        aria-labelledby="track-range-slider"
                        defaultValue={[Math.round(item.first_seen_seconds), Math.round(item.last_seen_seconds)]}
                        sx={redSliderStyle}
                    />
                  ))
                }
            </Box>
            {getFormatted(end?(end-start):start?(duration-start>0?duration-start:0):duration)}
        </Stack>
    )
}